import type React from 'react';
import { memo } from 'react';
import { cn } from '@/lib/utils';
interface LutsProps extends React.SVGProps<SVGSVGElement> {}
const _Luts = (props: LutsProps) => <svg aria-hidden="true" fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props} className={cn('size-4', props.className)} data-sentry-element="svg" data-sentry-component="_Luts" data-sentry-source-file="Luts.tsx">
    <path d="M6.85811 4.38331L11.6381 9.16331M13.5274 5.02464L4.75545 13.7966C4.63011 13.922 4.46078 13.992 4.28411 13.992H2.68678C2.31945 13.992 2.02078 13.6946 2.02011 13.3273L2.01611 11.7833C2.01611 11.606 2.08611 11.4353 2.21145 11.31L11.0121 2.50864C11.7068 1.81397 12.8334 1.81397 13.5281 2.50864C14.2228 3.20331 14.2221 4.32997 13.5274 5.02464Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33" data-sentry-element="path" data-sentry-source-file="Luts.tsx" />
  </svg>;
const Luts = memo(_Luts);
export const LutsWithIconTag = ({
  className
}: {
  className?: string;
}) => <i data-sentry-component="LutsWithIconTag" data-sentry-source-file="Luts.tsx">
    <Luts className={className} data-sentry-element="Luts" data-sentry-source-file="Luts.tsx" />
  </i>;
export default Luts;